module.exports = "/_next/static/images/567659d1a53e16b0a568b80098a4044f-rewards-app-lg@1x.png";